import * as angular from 'angular';
import {IController} from "angular";
import {RoutesService} from "../../../routes/services/routes-service.service";
import {RouteModel} from "../../../routes/models/route.model";

export class DeliveriesMapViewRoutesSideBarCtrl implements IController {
  checkedIds?: string[];
  checkedRoutes?: RouteModel[];
  range: any;
  branchIds: any;
  serviceAreaIds: any;
  expandedRoute: any;
  onSelect: Function;
  onCheckedChange: Function;

  private loadingTotals: any;
  private ACTIVE_STATUSES: any;
  private selectedStatusGroup: any;
  private statuses: any;
  private queryString: any;
  private totals: any;

  /* @ngInject */
  constructor(private routesService: RoutesService) {
  }

  $onInit() {
    this.loadingTotals = false;
    this.ACTIVE_STATUSES = ['Unassigned', 'InMarket', 'Assigned', 'Started'];
    this.selectedStatusGroup = 'Unassigned';
    this.statuses = ['Unassigned'];
    this._loadTotals();
  }

  $onChanges(changes) {
    if (changes.range && !changes.range.isFirstChange() ||
      changes.branchIds && !changes.branchIds.isFirstChange() ||
      changes.serviceAreaIds && !changes.serviceAreaIds.isFirstChange()) {
      if (!this.loadingTotals) {
        this._loadTotals();
      }
    }
  };

  onStatusChange(status) {
    this.selectedStatusGroup = status;
    this.statuses = status === 'Active' ? this.ACTIVE_STATUSES : (status ? [status] : undefined);
    this._loadTotals();
    this.onSelect();
  }

  onQueryChange(queryString) {
    this.queryString = queryString;
  }

  //from, to, branchIds, areaIds, statuses, query, tags
  private _loadTotals() {
    this.totals = undefined;
    this.loadingTotals = true;
    this.routesService.getRoutesStatusesTotals(
      undefined,
      this.range.dateStart,
      this.range.dateEnd,
      this.branchIds,
      this.serviceAreaIds,
      this.queryString
    )
      .then((totals) => {
        this.totals = totals;
      })
      .finally(() => {
        this.loadingTotals = false;
      })
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveriesMapViewRoutesSideBar', {
    bindings: {
      checkedIds: '<?',
      checkedRoutes: '<?',
      range: '<',
      branchIds: '<?',
      serviceAreaIds: '<?',
      expandedRoute: '<',
      onSelect: '&',
      onCheckedChange: '&'
    },
    template: require('./deliveries-map-view-routes-side-bar.html').default,
    controller: DeliveriesMapViewRoutesSideBarCtrl
  });
